import React from 'react';
import Script from 'next/script';
export 
function LoadBraintreeJS(enableBraintreeGPay: any, enableBraintreePaypal: any) {
  return <>
    {enableBraintreeGPay && (
      <Script src="https://pay.google.com/gp/p/js/pay.js" />
    )}
    <Script src="https://js.braintreegateway.com/web/3.136.0/js/client.min.js" />
    <Script src="https://js.braintreegateway.com/web/3.136.0/js/hosted-fields.min.js" />
    <Script src="https://js.braintreegateway.com/web/3.136.0/js/data-collector.min.js" />

    {enableBraintreePaypal && (
      <Script src="https://js.braintreegateway.com/web/3.136.0/js/paypal-checkout.min.js" />
    )}
    {enableBraintreeGPay && (
      <Script src="https://js.braintreegateway.com/web/3.136.0/js/google-payment.min.js" />
    )}
  </>;
}
